<template>
  <div>
    <!-- 头部 -->
    <div class="header_padding">

      <el-form
        :inline="true"
        class="demo-form-inline toolbar"
        style="padding-bottom: 0px"
      >
        <el-form-item
          label="老人姓名"
          style="margin-left: 30px"
          prop="typeName"
        >
          <el-input
            v-model.trim="oldmanName"
            placeholder="请输入老人姓名"
            clearable
            @keyup.enter.native.prevent="getDataList"
          ></el-input>
        </el-form-item>
        
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            plain
            style="margin-left: 20px"
            @click="getDataList"
          >
            查询</el-button>
        </el-form-item>
      </el-form>

    </div>
    <!-- table -->
    <div v-loading="loading" element-loading-text="拼命加载中......">
      <el-table
        :data="list"
        style="width: 100%;margin-top:-10px"
        :row-style="tableRowStyle"
        :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
        :header-cell-style="tableHeaderColor"
      >
        <el-table-column
          prop="oldmanName"
          label="老人姓名"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="idCard"
          label="身份证号"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="date"
          label="调整日期"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="total"
          label="补缴合计"
          align="center"
          width="140"
        ></el-table-column>
        <el-table-column
          prop="reason"
          label="调整原因"
          align="center"
          :formatter="formatReason"
        ></el-table-column>
        <el-table-column
          prop="state"
          label="状态"
          align="center"
          :formatter="formatStatys"
          width="140"
        ></el-table-column>
        <el-table-column label="操作" align="center" width="290">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              plain
              v-if="scope.row.state!=6"
              title="通过"
              @click.native="handleEnter(scope.row)"
              >通过</el-button
            >
            <el-button
              type="danger"
              size="mini"
              plain
              v-if="scope.row.state!=6"
              title="不通过"
              @click.native="handleCancel(scope.row)"
              >不通过
            </el-button>

            <el-button
              type="success"
              size="mini"
              plain
              title="查看"
              @click.native="handleShow(scope.row)"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        layout="total, prev, pager, next"
        :total="totalSize"
        :page-size="pageSize"
        align="center"
        class="fenye"
      ></el-pagination>

      <el-dialog
        title="你确定不通过调房调级申请吗?"
        center
        width="420px"
        :visible.sync="cancelDialogVisible"
      >
        <div class="demo-input-suffix">
          原因：
          <el-input
            placeholder="请输入内容"
            v-model.trim="remark"
            style="width: 300px"
          ></el-input>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button type="warning" @click="cancelDialogVisible = false"
            >取 消</el-button
          >
          <el-button type="primary" :loading="btnLoding" @click="cancel"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>

    <el-dialog
      title="你确定通过调房调级申请吗?"
      center
      width="380px"
      :visible.sync="enterDialogVisible"
    >
      <span slot="footer" class="dialog-footer">
        <el-button type="warning" @click="enterDialogVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" :loading="btnLoding" @click="enterClick"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
// 调房调级
import bus from "@/vuex/eventBus";
export default {
  name: "Form",
  data() {
    return {
      loading: false,
      list: [],
      pageNum: 1,
      btnLoding: false,
      roleCode: "",
      isServiceManage: false,
      enterText: "确认",
      totalSize: 0,
      pageSize: 10,
      oldmanName: "",
      enterDialogVisible: false,
      cancelDialogVisible: false,
      remark: "",
      currentItem: {}, //当前的item
    };
  },
  methods: {
    formatReason(row, column) {
      if (row.reason == 1) {
        return "身体条件变差";
      } else if (row.reason == 2) {
        return "老人不适应";
      } else if (row.reason == 3) {
        return "主动调整";
      }
    },
    formatStatys(row, column) {
      if(row.state == 6){
        return "已完成";
      }
      return "待审批";
    },
    //修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    //修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #d4f5fa;";
      }
    },
    //分页控件,
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getDataList();
    },
    //获取数据列表
    getDataList() {
      this.roleCode = sessionStorage.getItem("roleCode");
      console.log(this.roleCode);
      var info = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        oldmanName: this.oldmanName,
      };
      this.$post("fmc/revise/queryCurTask", info, "", "json").then((res) => {
        this.list = res.list;
        this.totalSize = Number(res.total);
        this.btnLoding = false;
        if (this.list.length > 0 && this.list[0].state == 2) {
          this.isServiceManage = true;
          this.enterText = "通过";
        }
      });
    },
    handleShow(row) {
      //跳转到 show界面
      //不缓存show界面
      console.log(row);
      bus.$emit("homePage", {
        type: "jump",
        path: "/changeFeeShow",
        title: "调房调级查看",
      });
      setTimeout(function () {
        //  bus.$emit("tftjId", {
        //   id : row.id,
        //   type: 2});
        if (row != null && row.id != null) {
          bus.$emit("tftjId", row.id + "," + 2);
        }
      }, 100);
    },
    handleEnter(row) {
      console.log(row);
      this.currentItem = row;
      this.enterDialogVisible = true;
    },
    enterClick() {
      console.log(this.currentItem);
      var id = this.currentItem.id;
      if (this.currentItem.state == 2) {
        //服务部长
        var info = {
          id: id,
          state: 1,
        };
        this.btnLoding = true;
        this.$post("fmc/revise/serviceApproval", info, "", "json").then(
          (res) => {
            this.$message({ type: "success", message: "审批成功" });
            this.getDataList();
            this.enterDialogVisible = false;
          },
          (err) => {
            this.$message({ type: "error", message: err.message });
          }
        );
      } else if (this.currentItem.state == 3) {
        //接待部长
        var info = {
          id: id,
        };
        this.btnLoding = true;
        this.$post("fmc/revise/admitConfirm", info, "", "json").then(
          (res) => {
            this.$message({ type: "success", message: "审批成功" });
            this.enterDialogVisible = false;
            this.getDataList();
          },
          (err) => {
            this.$message({ type: "error", message: err.message });
          }
        );
      } else if (this.currentItem.state == 5) {
        //收费室
        var info = {
          id: id,
        };
        this.btnLoding = true;
        this.$post("fmc/revise/chargeConfirm", info, "", "json").then(
          (res) => {
            this.$message({ type: "success", message: "审批成功" });
            this.getDataList();
            this.enterDialogVisible = false;
          },
          (err) => {
            this.$message({ type: "error", message: err.message });
          }
        );
      } 

      // if (this.roleCode == "serviceMinister") {

      // } else if (this.roleCode == "receptionist" || this.roleCode == "receptionMinister") {

      // } else if (this.roleCode == "charge") {

      // }
    },
    handleCancel(row) {
      console.log(row);
      this.currentItem = row;
      this.remark = "";
      this.cancelDialogVisible = true;
      console.log(this.cancelDialogVisible);
    },
    cancel() {
      //by guo 2019-12-03-14：42修改
      if (this.remark != "" && this.remark.length <= 50) {
        // if (this.remark != "") {
        var id = this.currentItem.id;
        var info = {
          id: id,
          state: 0,
          comment: this.remark,
        };
        this.btnLoding = true;
        this.$post("fmc/revise/serviceApproval", info, "", "json").then(
          (res) => {
            this.$message({ type: "success", message: "审批成功" });
            this.getDataList();
            this.cancelDialogVisible = false;
          },
          (err) => {
            this.$message({ type: "error", message: err.message });
          }
        );
        // } else {
        //   this.$message({ type: "error", message: "请填写不通过的原因" });
        // }
        //by guo 2019-12-03-14:42修改
      } else if (this.remark == "") {
        this.$message({ type: "error", message: "请填写不通过的原因" });
      } else if (this.remark.length > 50) {
        this.$message({
          type: "error",
          message: "调房调级申请不通过原因在 1到 50 个字符",
        });
      }
    },
  },
  mounted() {
    this.getDataList();
    //by guo 2019-11-14-19:15添加  监听刷新表格的数据
    //监听 待办事项页面的
    this.$bus.$on("refreshRoomUpgrade", () => {
      console.log("待办事项页面传来的");
      this.getDataList(); //刷新列表的数据
    });
  },
  computed: {},
};
</script>
<style scoped>
.header_padding {
  margin-bottom: 5px;
}
</style>